import { Phone, ArrowUp } from "lucide-react";
import { Button } from "../components/ui/button";
import { useState, useEffect } from "react";

const FloatingButtons = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleLineClick = () => {
    // trackConversion.lineClick("floating-button");
    window.open("https://line.me/R/ti/p/@sanookcar", "_blank");
  };

  const handleWhatsAppClick = () => {
    // trackConversion.whatsappClick("floating-button");
    window.open("https://wa.me/66952215764", "_blank");
  };

  const handleCallClick = () => {
    // trackConversion.phoneClick("floating-button");
    window.location.href = "tel:+66952215764";
  };

  return (
    <>
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes bounceSubtle {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-3px);
          }
        }

        .btn-fade-in {
          animation: fadeIn 0.5s ease-out forwards;
          opacity: 0;
        }

        .btn-slide-up {
          animation: slideUp 0.4s ease-out forwards;
        }

        .btn-bounce {
          animation: bounceSubtle 2s ease-in-out infinite;
        }

        .btn-glow {
          position: relative;
        }

        .btn-glow::before {
          content: '';
          position: absolute;
          inset: 0;
          border-radius: 9999px;
          opacity: 0;
          transition: opacity 0.5s;
          filter: blur(12px);
        }

        .btn-glow:hover::before {
          opacity: 0.6;
        }

        .btn-glow.line::before {
          background: #06C755;
        }

        .btn-glow.whatsapp::before {
          background: #25D366;
        }

        .btn-glow.phone::before {
          background: var(--primary);
        }

        .btn-glow.scroll::before {
          background: var(--secondary);
        }

        .icon-rotate {
          transition: transform 0.3s;
        }

        .btn-glow:hover .icon-rotate {
          transform: rotate(12deg);
        }

        .scroll-arrow {
          transition: transform 0.3s;
        }

        .btn-glow:hover .scroll-arrow {
          transform: translateY(-4px);
        }
      `}</style>

      <div className="fixed bottom-4 right-4 sm:bottom-5 sm:right-5 md:bottom-6 md:right-6 flex flex-col gap-2.5 sm:gap-3 md:gap-4 z-50">
        {/* LINE Button with Official Logo - Mobile First */}
        <div className="btn-fade-in" style={{ animationDelay: '0.1s' }}>
          <Button
            size="icon"
            className="btn-glow line btn-bounce h-12 w-12 sm:h-14 sm:w-14 md:h-16 md:w-16 rounded-full bg-gradient-to-br from-[#06C755] to-[#05b34d] hover:from-[#05b34d] hover:to-[#049944] text-white shadow-xl hover:shadow-2xl hover:scale-110 active:scale-95 transition-all duration-300"
            onClick={handleLineClick}
            aria-label="Chat on LINE"
          >
            <svg viewBox="0 0 24 24" className="icon-rotate h-6 w-6 sm:h-7 sm:w-7 md:h-8 md:w-8" fill="currentColor">
              <path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63h2.386c.346 0 .627.285.627.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63.346 0 .628.285.628.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.282.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314"/>
            </svg>
          </Button>
        </div>

        {/* WhatsApp Button with Official Logo - Mobile First */}
        <div className="btn-fade-in" style={{ animationDelay: '0.2s' }}>
          <Button
            size="icon"
            className="btn-glow whatsapp btn-bounce h-12 w-12 sm:h-14 sm:w-14 md:h-16 md:w-16 rounded-full bg-gradient-to-br from-[#25D366] to-[#20bd5a] hover:from-[#20bd5a] hover:to-[#1ca950] text-white shadow-xl hover:shadow-2xl hover:scale-110 active:scale-95 transition-all duration-300"
            onClick={handleWhatsAppClick}
            aria-label="Chat on WhatsApp"
          >
            <svg viewBox="0 0 24 24" className="icon-rotate h-6 w-6 sm:h-7 sm:w-7 md:h-8 md:w-8" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
            </svg>
          </Button>
        </div>

        {/* Phone Button - Mobile First */}
        <div className="btn-fade-in" style={{ animationDelay: '0.3s' }}>
          <Button
            size="icon"
            className="btn-glow phone btn-bounce h-12 w-12 sm:h-14 sm:w-14 md:h-16 md:w-16 rounded-full bg-gradient-to-br from-primary to-primary/80 hover:from-primary/90 hover:to-primary/70 text-white shadow-xl hover:shadow-2xl hover:scale-110 active:scale-95 transition-all duration-300"
            onClick={handleCallClick}
            aria-label="Call us"
          >
            <Phone className="icon-rotate h-5 w-5 sm:h-6 sm:w-6 md:h-7 md:w-7" />
          </Button>
        </div>

        {/* Scroll to Top Button - Mobile First */}
        {showScrollTop && (
          <div className="btn-slide-up">
            <Button
              size="icon"
              className="btn-glow scroll h-12 w-12 sm:h-14 sm:w-14 md:h-16 md:w-16 rounded-full bg-gradient-to-br from-secondary to-secondary/80 hover:from-secondary/90 hover:to-secondary/70 text-white shadow-xl hover:shadow-2xl hover:scale-110 active:scale-95 transition-all duration-300"
              onClick={scrollToTop}
              aria-label="Scroll to top"
            >
              <ArrowUp className="scroll-arrow h-5 w-5 sm:h-6 sm:w-6 md:h-7 md:w-7 animate-pulse" />
            </Button>
          </div>
        )}
      </div>
    </>
  );
};

export default FloatingButtons;
